import React from "react";
import "./App.css";
import NavBarLayout from "./NavbarLayout";
import Button from "@mui/material/Button";
import { useNavigate, useLocation } from "react-router-dom";
import { buttonStyle } from "./colors";
import { Grid } from "@mui/material";

import Top8 from "./outfits/top 8.png";
import Top9 from "./outfits/top 9.png";
import Top10 from "./outfits/top 10.png";
import Top11 from "./outfits/top 11.png";
import Top12 from "./outfits/top 12.png";
import Top13 from "./outfits/top 13.png";
import Top15 from "./outfits/top 15.png";
import Top16 from "./outfits/top 16.png";
import Top17 from "./outfits/top 17.png";

import Bottom3 from "./outfits/bottom 3.png";
import Bottom4 from "./outfits/bottom 4.png";
import Bottom5 from "./outfits/bottom 5.png";

function AutoAddResults() {
  const navigate = useNavigate();
  const { state } = useLocation();
  var NEW_OUTFITS = {
    Photos: [
      {
        id: 0,
        imageId: Top8,
        type: "top",
        new: true,
        alt: "A beige trench coat",
      },
      {
        id: 1,
        imageId: Top9,
        type: "top",
        new: true,
        alt: "A gray wind jacket",
      },
      { id: 2, imageId: Top10, type: "top", new: true, alt: "A denim jacket" },
      {
        id: 3,
        imageId: Top11,
        type: "top",
        new: true,
        alt: "A black tank top with a square neckline",
      },
      {
        id: 10,
        imageId: Bottom4,
        type: "bottom",
        new: true,
        alt: "Gray sweatpants",
      },
      {
        id: 11,
        imageId: Bottom5,
        type: "bottom",
        new: true,
        alt: "Denim overalls",
      },
    ],
    Email: [
      { id: 4, imageId: Top12, type: "top", new: true, alt: "A black t-shirt" },
      {
        id: 5,
        imageId: Top13,
        type: "top",
        new: true,
        alt: "A pink long sleeve crop top with lacey floral patterning",
      },
      {
        id: 6,
        imageId: Top15,
        type: "top",
        new: true,
        alt: "A long, dark brown leather coat",
      },
      {
        id: 7,
        imageId: Top16,
        type: "top",
        new: true,
        alt: "A black puffer jacket",
      },
      {
        id: 8,
        imageId: Top17,
        type: "top",
        new: true,
        alt: "A black tank top with a curved neckline",
      },
      {
        id: 9,
        imageId: Bottom3,
        type: "bottom",
        new: true,
        alt: "Dark gray cargo pants",
      },
    ],
  };
  const [newClothes, setNewClothes] = React.useState(NEW_OUTFITS[state.type]);

  const handleDiscard = (value) => {
    setNewClothes((oldValues) => {
      return oldValues.filter((outfit) => outfit !== value);
    });
  };

  return (
    <NavBarLayout
      title={"Add From " + state.type}
      onBackButtonClicked={() => navigate("/addmethods")}
      active={1}
    >
      <div className="AutoAddResults-container">
        <span className="AddMethod-instructionsText">
          Here's what was found in your {state.type.toLowerCase()}!
        </span>
        <div className="AutoAddResults-clothes-container">
          <div>
            <span className="MyCloset-caption">Tops </span>
            <Grid container spacing={1} rowGap={1}>
              {newClothes
                .filter((outfit) => outfit.type === "top")
                .map((outfit) => (
                  <Grid item xs={4} key={outfit.id}>
                    <div className="MyCloset-outfitContainer">
                      <img
                        style={{ height: "15vh", width: "120%" }}
                        src={outfit.imageId}
                        alt={outfit.alt}
                      ></img>
                    </div>
                    <Button
                      onClick={() => handleDiscard(outfit)}
                      sx={{
                        padding: 1,
                        paddingY: 0.5,
                        fontSize: 12,
                        ...buttonStyle,
                      }}
                      variant="contained"
                    >
                      Discard
                    </Button>
                  </Grid>
                ))}
            </Grid>
          </div>
          <div>
            <span className="MyCloset-caption">Bottoms </span>
            <Grid container spacing={2} rowSpacing={0.01}>
              {newClothes
                .filter((outfit) => outfit.type === "bottom")
                .map((outfit) => (
                  <Grid item xs={4} key={outfit.id}>
                    <div className="MyCloset-outfitContainer">
                      <img
                        style={{ height: "15vh" }}
                        src={outfit.imageId}
                        alt={outfit.alt}
                      ></img>
                    </div>
                    <Button
                      onClick={() => handleDiscard(outfit)}
                      sx={{
                        padding: 1,
                        paddingY: 0.5,
                        fontSize: 12,
                        ...buttonStyle,
                      }}
                      variant="contained"
                    >
                      Discard
                    </Button>
                  </Grid>
                ))}
            </Grid>
          </div>
        </div>
      </div>
      <Button
        onClick={() => {
          navigate("/mycloset", { state: { newClothes: newClothes } });
        }}
        sx={{ fontSize: 20, margin: "1rem", top: "90%", ...buttonStyle }}
        variant="contained"
      >
        Add to My Closet
      </Button>
    </NavBarLayout>
  );
}

export default AutoAddResults;
